"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var components_1 = require("./components");
var ui_1 = require("@vidazoo/ui");
var theme = require("../../styles/baseForm.scss");
var Tags = /** @class */ (function (_super) {
    tslib_1.__extends(Tags, _super);
    function Tags(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.downloadCsv = function () {
            var downloadCSV = _this.props.downloadCSV;
            downloadCSV();
        };
        _this.onSelectDemandPartner = function (value) {
            var selectDemandPartner = _this.props.selectDemandPartner;
            selectDemandPartner(value);
        };
        _this.onRemoveDemandPartner = function (value) {
            var removeDemandPartner = _this.props.removeDemandPartner;
            removeDemandPartner(value);
        };
        _this.getReport = function () {
            var getItems = _this.props.getItems;
            getItems();
        };
        _this.onChangeType = function (type) {
            var changeType = _this.props.changeType;
            changeType(type);
        };
        return _this;
    }
    Tags.prototype.componentDidMount = function () {
        var _a = this.props, getDemandPartners = _a.getDemandPartners, header = _a.header;
        if (header) {
            getDemandPartners();
        }
        else {
            this.getReport();
        }
    };
    Tags.prototype.renderLoader = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(ui_1.Loader, { size: 1, gray: true, className: theme.loader }),
            React.createElement(ui_1.PageMessage, { small: true, title: "Loading Ads Txt report", description: "Please wait..." })));
    };
    Tags.prototype.render = function () {
        var _a = this.props, loadMore = _a.loadMore, searchQueries = _a.searchQueries, onSearch = _a.onSearch, isLoading = _a.isLoading, items = _a.items, density = _a.density, sortBy = _a.sortBy, sortDirection = _a.sortDirection, onSort = _a.onSort, demandPartners = _a.demandPartners, selectedDemandPartners = _a.selectedDemandPartners, header = _a.header, type = _a.type;
        return (React.createElement(ui_1.PageContainer, { className: theme.form, pageTitle: "Ads Txt report", top: 1.2 },
            React.createElement("div", { className: theme.header },
                React.createElement(ui_1.PageTitle, { iconName: "icon-reporting", label: "Ads Txt" }),
                React.createElement(ui_1.ButtonsGroup, { dark: true, borders: true, active: type, onChange: this.onChangeType },
                    React.createElement(ui_1.GroupButton, { name: "website" }, "Website"),
                    React.createElement(ui_1.GroupButton, { name: "app" }, "App"))),
            header ? (React.createElement(ui_1.Surface, { className: theme.headerPadding, level: 1 },
                React.createElement(ui_1.FormChips, { name: "selectedDemandPartners", allowOrder: false, onSelect: this.onSelectDemandPartner, itemLabelKey: "name", itemValueKey: "_id", onDelete: this.onRemoveDemandPartner, chips: selectedDemandPartners, label: "Select Demand Partners (optional)", allowCreate: false, dataSource: demandPartners, fill: true, maxItems: 5, infoPosition: "bottom" }),
                React.createElement("div", { className: theme.buttons },
                    React.createElement(ui_1.Button, { medium: true, blue: true, onClick: this.getReport }, "Get Report"),
                    React.createElement(ui_1.Button, { iconName: "icon-download", medium: true, outline: true, blue: true, onClick: this.downloadCsv }, "Download CSV")))) : null,
            !isLoading && (items.length > 0) ? (React.createElement(components_1.List, { searchQueries: searchQueries, onSearch: onSearch, sortBy: sortBy, sortDirection: sortDirection, onSort: onSort, items: items, density: density, loadMore: loadMore, type: type })) : null,
            isLoading ? this.renderLoader() : null));
    };
    Tags.defaultProps = {};
    return Tags;
}(React.Component));
exports.default = Tags;
